import type { ApItemType } from "@/accounts-payable/types";

export const stJobUrl = (id: number) => `/#/Job/Index/${id}`;
export const stInvoiceUrl = (id: number) => `/#/EditInvoice/${id}`;
export const stProjectUrl = (id: number) => `/#/project/${id}`;

/** Where a document's cost is filed in ServiceTitan: its job, or a project with no job. */
export interface StFilingTarget {
  kind: "job" | "project";
  id: number;
  url: string;
  /** "Job #123" / "Project #456" */
  label: string;
}

export const stFilingTarget = (document: {
  st_job_external_id?: number | null;
  st_project_external_id?: number | null;
}): StFilingTarget | null => {
  if (document.st_job_external_id)
    return {
      kind: "job",
      id: document.st_job_external_id,
      url: stJobUrl(document.st_job_external_id),
      label: `Job #${document.st_job_external_id}`,
    };
  if (document.st_project_external_id)
    return {
      kind: "project",
      id: document.st_project_external_id,
      url: stProjectUrl(document.st_project_external_id),
      label: `Project #${document.st_project_external_id}`,
    };
  return null;
};
export const stPurchaseOrderUrl = (id: number) =>
  `/#/new/inventory/purchase-orders/details/${id}`;
export const stPricebookItemUrl = (type: ApItemType, id: number) =>
  `/#/Settings/Pricebook/${
    type === "equipment" ? "Equipment" : "Materials"
  }/Edit/${id}`;
